<dx-popup [title]="title"
          [visible]="isVisible"
          [shading]="true"
          [resizeEnabled]="false"
          [closeOnOutsideClick]="false"
          (onHiding)="cancelRequest()">
  <form id="reportForm" (submit)="submitReport($event)">
    <dx-scroll-view #scrollView [height]="getContentHeight()" [direction]="'both'" [useNative]="true">
      <div class="dx-fieldset">
        <div class="dx-fieldset-header">{{'General' | translate }}</div>
        <div class="grid-fieldset">
          <div>
            <div class="grid-row">
              <div class="label">{{'STMID' | translate}}</div>
              <dx-text-box [(value)]="report.STMID" [readOnly]="true"></dx-text-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'ESTMID' | translate}}</div>
              <dx-text-box [(value)]="report.ESTMID"></dx-text-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Source' | translate}}</div>
              <dx-select-box [items]="sources" [(value)]="report.Source"></dx-select-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Created Date' | translate}}</div>
              <dx-date-box type="datetime" [dateSerializationFormat]="'yyyy-MM-ddTHH:mm:ss'" [displayFormat]="'dd.MM.yyyy HH:mm:ss'" [(value)]="report.CreatedDate"
                           (onOpened)="setTodayButton($event)"></dx-date-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'User ID' | translate}}</div>
              <dx-text-box [(value)]="report.UserName" [readOnly]="true"></dx-text-box>
            </div>
          </div>
          <div>
            <div class="grid-row">
              <div class="label">{{'Division' | translate}}</div>
              <dx-select-box [dataSource]="divisions" [displayExpr]="'Name'" [valueExpr]="'Name'"
                             [(value)]="report.Division" [disabled]="true"></dx-select-box>
            </div>
            <div class="grid-row" *ngIf="report.Division?.toUpperCase() === 'GAS'">
              <div class="label">{{'Has Gas Detected' | translate}}</div>
              <dx-check-box [(value)]="report.HasGasDetected"></dx-check-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Is Emergency' | translate}}</div>
              <dx-check-box [(value)]="report.IsEmergency"></dx-check-box>
            </div>
          </div>
        </div>
      </div>
      <div class="dx-fieldset">
        <div class="dx-fieldset-header">{{'Reporter Data' | translate }}</div>
        <div class="grid-fieldset before-remark">
          <div>
            <div class="grid-row">
              <div class="label">{{'Reporter Name' | translate}}</div>
              <div>
                <dx-validation-group #validationGroupReporterName>
                  <dx-text-box [(value)]="report.ReporterName">
                    <dx-validator>
                      <dxi-validation-rule type="required" message="{{'Reporter Name is required!' | translate}}"></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </dx-validation-group>
              </div>
            </div>
            <div class="grid-row">
              <div class="label">{{'Reporter Surname' | translate}}</div>
              <div>
                <dx-validation-group #validationGroupReporterSurname>
                  <dx-text-box [(value)]="report.ReporterSurname">
                    <dx-validator>
                      <dxi-validation-rule type="required"
                                           message="{{'Reporter Surname is required!' | translate}}"></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </dx-validation-group>
              </div>
            </div>
            <div class="grid-row">
              <div class="label">{{'Reporter Postal Code' | translate}}</div>
              <div>
                <dx-autocomplete placeholder="{{'Enter postal code...' | translate}}"
                                 [valueChangeEvent]="'blur'"
                                 [(value)]="report.ReporterPostalCode"
                                 [dataSource]="reporterPostalCodes"
                                 [searchMode]="'startswith'"
                                 (onValueChanged)="onReporterPostalCodeChanged($event)"></dx-autocomplete>
              </div>
            </div>
            <div class="grid-row">
              <div class="label">{{'Reporter City' | translate}}</div>
              <div>
                <dx-autocomplete placeholder="{{'Enter city...' | translate}}"
                                 [valueChangeEvent]="'blur'"
                                 [(value)]="report.ReporterCity"
                                 [dataSource]="reporterCities"
                                 [searchMode]="'startswith'"
                                 (onValueChanged)="onReporterCityChanged($event)"></dx-autocomplete>
              </div>
            </div>
            <div class="grid-row">
              <div class="label">{{'Reporter Street' | translate}}</div>
              <div>
                <dx-autocomplete placeholder="{{'Enter street...' | translate}}"
                                 [valueChangeEvent]="'blur'"
                                 [(value)]="report.ReporterStreet"
                                 [dataSource]="reporterStreets"
                                 [searchMode]="'startswith'"
                                 (onValueChanged)="onReporterStreetChanged($event)"></dx-autocomplete>
              </div>
            </div>
            <div class="grid-row">
              <div class="label">{{'Reporter House No.' | translate}}</div>
              <div>
                <dx-autocomplete placeholder="{{'Enter house number...' | translate}}"
                                 [valueChangeEvent]="'blur'"
                                 [(value)]="report.ReporterHouseNo"
                                 [dataSource]="reporterHouseNos"
                                 [searchMode]="'startswith'"></dx-autocomplete>
              </div>
            </div>
          </div>
          <div>
            <div class="grid-row">
              <div class="label">{{'Reporter Phone' | translate}}</div>
              <dx-text-box [(value)]="report.ReporterPhone"></dx-text-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Reporter City Part' | translate}}</div>
              <dx-autocomplete [(value)]="report.ReporterCityPart"
                               [valueChangeEvent]="'blur'"
                               [dataSource]="reporterCityParts"
                               [searchMode]="'startswith'"></dx-autocomplete>
            </div>
          </div>
        </div>
        <div class="remark">
          <div class="label">{{'Reporter Remarks' | translate}}</div>
          <dx-text-area [(value)]="report.ReporterRemarks" [height]="90"></dx-text-area>
        </div>
      </div>
      <div class="dx-fieldset">
        <div class="dx-fieldset-header">{{'Incident Location' | translate }}</div>
        <div class="grid-fieldset before-remark">
          <div>
            <div class="grid-row">
              <div class="label">{{'Incident Name' | translate}}</div>
              <dx-text-box [(value)]="report.IncidentName"></dx-text-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Incident Surname' | translate}}</div>
              <dx-text-box [(value)]="report.IncidentSurname"></dx-text-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Incident Postal Code' | translate}}</div>
              <dx-autocomplete placeholder="{{'Enter postal code...' | translate}}"
                               [(value)]="report.IncidentPostalCode"
                               [dataSource]="incidentPostalCodes"
                               [searchMode]="'startswith'"
                               (onValueChanged)="onIncidentPostalCodeChanged($event)"></dx-autocomplete>
            </div>
            <div class="grid-row">
              <div class="label">{{'Incident City' | translate}}</div>
              <dx-autocomplete placeholder="{{'Enter city...' | translate}}"
                               [(value)]="report.IncidentCity"
                               [dataSource]="incidentCities"
                               [searchMode]="'startswith'"
                               (onValueChanged)="onIncidentCityChanged($event)"></dx-autocomplete>
            </div>
            <div class="grid-row">
              <div class="label">{{'Incident Street' | translate}}</div>
              <dx-autocomplete placeholder="{{'Enter street...' | translate}}"
                               [(value)]="report.IncidentStreet"
                               [dataSource]="incidentStreets"
                               [searchMode]="'startswith'"
                               (onValueChanged)="onIncidentStreetChanged($event)"></dx-autocomplete>
            </div>
            <div class="grid-row">
              <div class="label">{{'Incident House No.' | translate}}</div>
              <dx-autocomplete placeholder="{{'Enter house number...' | translate}}"
                               [(value)]="report.IncidentHouseNo"
                               [dataSource]="incidentHouseNos"
                               [searchMode]="'startswith'"></dx-autocomplete>
            </div>
          </div>
          <div>
            <div class="grid-row">
              <div class="label">{{'Incident Phone' | translate}}</div>
              <dx-text-box [(value)]="report.IncidentPhone"></dx-text-box>
            </div>
            <div class="grid-row">
              <div class="label">{{'Incident City Part' | translate}}</div>
              <dx-autocomplete [(value)]="report.IncidentCityPart"
                               [dataSource]="incidentCityParts"
                               [searchMode]="'startswith'"></dx-autocomplete>
            </div>
          </div>
        </div>
        <div class="remark">
          <div class="label">{{'Incident Remarks' | translate}}</div>
          <dx-text-area [(value)]="report.IncidentRemarks" [height]="90"></dx-text-area>
        </div>
      </div>
      <div class="dx-fieldset">
        <div class="dx-fieldset-header">{{'Location' | translate }}</div>
        <div class="grid-fieldset">
          <div>
            <div class="grid-row">
              <div class="label">{{'Location' | translate}}</div>
              <dx-autocomplete [(value)]="report.Location"
                               [dataSource]="locations"
                               [searchMode]="'startswith'"></dx-autocomplete>
            </div>
          </div>
        </div>
      </div>
      <div class="dx-fieldset">
        <div class="dx-fieldset-header">{{'Initial Safeguarding Measures' | translate }}</div>
        <div class="grid-fieldset">
          <div>
            <div class="grid-row">
              <div class="label break-space">{{'Initial Safeguarding Measures were read out' | translate}}</div>
              <dx-check-box [(value)]="report.InitialSafeguardingMeasures"></dx-check-box>
            </div>
          </div>
        </div>
      </div>
      <app-file-management [rowKey]="report?.IncidentKey"></app-file-management>
      <div class="dx-fieldset">
        <div class="images">
          <app-report-image *ngIf="selectedReportImage; else infoText"
                            [reportImage]="selectedReportImage"></app-report-image>
          <ng-template #infoText>
            <p>{{'Division report images not found' | translate }}</p>
          </ng-template>
        </div>
      </div>
    </dx-scroll-view>
    <dx-scroll-view width="100%" height="100%" [direction]="'horizontal'" [useNative]="true">
      <div class="footer" [ngClass]="{ 'single-column': !incidentManagementEnabled }">
        <div class="left-buttons" *ngIf="incidentManagementEnabled">
          <dx-button id="btnIncidentModal" *ngIf="btnIncidentModalText" [text]="btnIncidentModalText"
                     (click)="openIncidentModal($event)" type="success"></dx-button>
          <ng-template [ngIf]="!report.HasReferences">
            <dx-button id="btnReference" text="{{'Add reference to Incident' | translate}}" type="success"
                       (click)="referenceReport()"></dx-button>
          </ng-template>
        </div>
        <div class="right-buttons">
          <dx-button id="btnSave" text="{{'Save' | translate}}" type="success" [useSubmitBehavior]="true"></dx-button>
          <dx-button id="btnCancel" text="{{'Cancel' | translate}}" type="default"
                     (click)="cancelRequest()"></dx-button>
        </div>
      </div>
    </dx-scroll-view>
  </form>
</dx-popup>


